import { ItnlIntegrationScript } from "@/data/types/ItnlIntegrationScript";

export const loadExternalScripts = (scripts: ItnlIntegrationScript[]) => {
    for (let script of scripts) {
        let existingScript:HTMLScriptElement | null = null;
        if(script.skipIfExists){
            existingScript = document.getElementById(script.id) as HTMLScriptElement;
        }
        if(existingScript === null){
            const scriptElem = document.createElement('script');
            if(script.scriptContent)
                scriptElem.textContent = script.scriptContent;
            if(script.url)
                scriptElem.src = script.url;
            if(script.attrs){
                script.attrs.forEach(attr => scriptElem.setAttribute(attr[0],attr[1]));
            }
            scriptElem.async = true;
            scriptElem.id = script.id;
            if(script.delay){
                setTimeout(()=>document.body.appendChild(scriptElem),script.delay)
            }else{
                document.body.appendChild(scriptElem);
            }
            scriptElem.onload = ()=>{
                scriptElem.setAttribute('data-loaded', "true");
                if(script.onLoadScripts){
                    loadExternalScripts(script.onLoadScripts?script.onLoadScripts:[])
                }
            }
        }else if(script.onLoadScripts){
            if(existingScript.getAttribute('data-loaded') === 'true'){
                loadExternalScripts(script.onLoadScripts?script.onLoadScripts:[]);
                
            }else{
                existingScript.onload = ()=>{
                    if(existingScript === null){
                        existingScript = document.getElementById(script.id) as HTMLScriptElement;
                    }
                    existingScript.setAttribute('data-loaded', "true");
                    loadExternalScripts(script.onLoadScripts?script.onLoadScripts:[]);
                }
            }
        }
    }
}

export const removeScripts = (scripts: ItnlIntegrationScript[]) => {
    scripts.forEach(script => {
        const scriptElem = document.getElementById(script.id);
        if (scriptElem !== null) {
            if(!script.retainScript)
                document.body.removeChild(scriptElem);
            if(script.onLoadScripts){
                removeScripts(script.onLoadScripts);
            }
        }
    });
}